module.exports = __webpack_public_path__ + "static/media/arrow_right.133b4d63.svg";